import { useEffect, useState } from 'react';
import { useContent } from '../../../hooks/use-server-content';

export interface DyfFeatureGuideContentProps {
    ownerManuals5050Title: string;
    ownerManuals5050Body: string;
    ownerManuals5050Image: string;
    ownerManuals5050ImageAltText: string;
    ownerManuals5050ButtonLabel: string;
    howToVideos5050Title: string;
    howToVideos5050Body: string;
    howToVideos5050Image: string;
    howToVideos5050ImageAltText: string;
    howToVideos5050ButtonLabel: string;
    defaultArticleCardImage: string;
    vehicleFeaturesTitle: string;
    vehicleFeaturesSignInDescription: string;
    categoryDropdownLabel: string;
    allFeaturesCheckbox: string;
    myBookmarksCheckbox: string;
    bookmarkImageAltText?: string;
    defaultArticleCardImageAltText: string;
    bookmarkAriaLabel: string;
    billboardBodyText?: string;
    featureGuideTitle: string;
    ymmBillboardAuthDescription: string;
    ymmBillboardUnauthDescription: string;
    featureGuideDescription: string;
    trimDropDownLabel: string;
    trimDropDownAriaLabel: string;
    accessYourGuideButtonLabel: string;
    accessYourGuideButtonAriaLabel: string;
    featureGuideAltDescription: string;
    exploreButtonLabel: string;
    billboardImageAltText: string;
    billboardTitle: string;
    billboardBody: string;
    featureRibbonAccordionTitle: string;
    featureRibbonAccordionDescription: string;
    featureRibbonTowingTitle: string;
    featureRibbonTowingButtonLabel: string;
    showMoreButton: string;
    paginationText: string;
    paginationDisplayText: string;
    longDescriptionTitle: string;
    categoryRelatedArticlesTitle: string;
    mobileAccordionLabel: string;
    noArticlesAreBookmarkedMessage: string;
    ymmSelectorTitle: string;
    ymmSelectorUnauthDescription: string;
    ymmSelectorAuthDescription: string;
    ymmSelectorDropdownLabel: string;
    signInButton: string;
    submitButton: string;
    zeroCarYmmSelectorDescription: string;
    vehicleSelectorButtonText: string;
}

export const useFeatureGuideContent = (): DyfFeatureGuideContentProps | null => {
    const [content, getValueByName] = useContent(
        'dyf',
        'feature-guide/dyf-feature-guide'
    );

    const [
        contentFragment,
        setContentFragment,
    ] = useState<DyfFeatureGuideContentProps | null>(null);

    useEffect(() => {
        if (content) {
            const tmp = {} as DyfFeatureGuideContentProps;

            content?.elements.forEach(element => {
                tmp[
                    element.name as keyof DyfFeatureGuideContentProps
                ] = getValueByName(`${element.name}`) as string;
            });
            setContentFragment(tmp);
        }
    }, [content]);

    return contentFragment;
};
